<div class="progress-text">
    <span>{{progressText}}</span>
</div>
<div class="first" title="Progressão dos modulos">
    <div class="second" [ngStyle]="{'width.%':width}"></div>
</div>